<template>
  <header className="navigation">
    <div className="navigation__logo">
      <figure>
        <img
          class="icon"
          alt="Vue logo"
          src="../../assets/images/logo-branco.png"
        />
      </figure>
    </div>
    <nav className="navigation__nav">
      <ul className="navigation__list">
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/cultura" exact>Cultura</router-link>
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/historia" exact>História</router-link>
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/gestao-pessoas" exact>Gestão de Pessoas</router-link>
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/dna" exact>DNA de Liderança</router-link>
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/okrs" exact>OKRs</router-link>
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/programa-integridade" exact>Programa de Integridade</router-link>
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/estrutura" exact>Estrutura</router-link>
        <!-- <router-link tag="li" class="navigation__item link-white" class-active="active" to="/educa-pixeon" exact>Educa Pixeon</router-link> -->
        <router-link tag="li" class="navigation__item link-white" class-active="active" to="/solucoes" exact>Soluções</router-link>
      </ul>
    </nav>
    <div>
      <el-button round @click="logout">Sair</el-button>
    </div>
  </header>
</template>

<script>
import { getAuth } from 'firebase/auth'

export default {
  setup () {
    const auth = getAuth()
    const logout = () => {
      auth.signOut()
    }
    return {
      logout
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/variables.scss";

.el-button {
  background: none !important;
  color:$white !important
}
</style>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.navigation {
  @include gradientBackground;
  color: $white;
  min-height: 10rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 0.1rem solid $white;
  padding: 0 4vw;
  font-size: 1.4rem;

  &__nav {
    max-width: 70%;
    text-align: center;
  }

  &__logo {
    width: 4rem;
    height: 5.5rem;
    padding-top: 0.5rem;
    cursor: pointer;
    img {
      height: 4.5rem;
    }
  }

  &__list {
    list-style: none;
    .router-link-active::before {
      transform: scaleX(1);
    }
  }

  &__item {
    padding-top: 1rem;
    position: relative;
    display: inline-block;
    margin-left: 2.9rem;
    cursor: pointer;
    font-size: 1.5rem;
    color: $white;

    &::before {
      content: "";
      position: absolute;
      bottom: -0.5rem;
      right: 0;
      height: 0.2rem;
      width: 100%;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.4s;
    }

    &:hover::before {
      transform: scaleX(1);
    }

    // &:last-child::before {
    //   width: 0;
    // }

    // &:last-child {
    //   .navigation__link {
    //     margin-left: 6rem;
    //     color: $white;
    //   }
    // }
  }

  &__link {
    color: $white;
    transition: color 0.5s ease;
  }

  &__link:hover {
    color: $white;
  }

}

.link-white {
  @include navigation-item-color($white);
}

</style>
